import { useEffect } from "react";

import { usePatientBaseline } from "features/patients/hooks/usePatientBaseline";
import { parseLegacyBp } from "features/pregnancy/utils/parseLegacyBp";

export const useBaselinePrefill = ({ form, patientId }) => {
  const { data: patientBaseline } = usePatientBaseline(patientId);

  useEffect(() => {
    if (!patientBaseline) return;
    const prefill = {};
    if (!form.getValues("maternalHeightCm") && patientBaseline.heightCm)
      prefill.maternalHeightCm = String(patientBaseline.heightCm);
    if (patientBaseline.bloodPressure) {
      const bp = parseLegacyBp(patientBaseline.bloodPressure);
      if (!form.getValues("bloodPressureSystolic") && bp.systolic)
        prefill.bloodPressureSystolic = bp.systolic;
      if (!form.getValues("bloodPressureDiastolic") && bp.diastolic)
        prefill.bloodPressureDiastolic = bp.diastolic;
    }
    if (Object.keys(prefill).length > 0)
      form.reset({ ...form.getValues(), ...prefill });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientBaseline]);
};
